import * as React from 'react';

/**
 * Legacy /register is retired — signup lives on rl-web now.
 *
 * The old form posted to Flask POST /user/register, which is the route the
 * Jul/Aug 2026 bot wave used: 116 accounts in 60 days, 4 with a child and 6
 * ever logged in. Only two of those were plausibly real, both on 8 Jul.
 * That route now returns 410, so leaving the form in place would just show
 * people an error.
 *
 * Redirects rather than rendering a "moved" page: anyone landing here wants
 * to sign up, and an extra click loses some of them. window.location.replace
 * keeps it out of the back-history so Back returns to wherever they came
 * from instead of bouncing them forward again.
 */
const NEW_SIGNUP_URL = 'https://rocketlearning.uk/register';

export default function RegisterRedirect() {
  React.useEffect(() => {
    window.location.replace(NEW_SIGNUP_URL);
  }, []);

  // Shown only for the instant before the redirect lands, and as the
  // fallback if JS is disabled — hence the real anchor.
  return (
    <div style={{ padding: '48px 24px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h2>Signing up has moved</h2>
      <p>
        Taking you to <a href={NEW_SIGNUP_URL}>rocketlearning.uk/register</a>…
      </p>
    </div>
  );
}
